export enum FordProtectPlanType {
  REVIEW_PLAN = 'RVP',
  OTHER_PLANS = 'OTP',
  REVIEW_AND_OTHER_PLANS = 'RAO'
}

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'PER',
  MONETARY_VALUE: 'VAL',
};

export const LANGUAGES = [
  {
    value: 'pt-BR',
    country: 'BRA',
    description: 'PT-BR',
    img: '../../assets/img/flags/Icon_PT_BR.png',
    active: true,
  },
  {
    value: 'es-AR',
    country: 'ARG',
    description: 'ES-AR',
    img: '../../assets/img/flags/Icon_ES_AR.png',
    active: true,
  },
  {
    value: 'en-US',
    country: '',
    description: 'EN-US',
    img: '../../assets/img/flags/Icon_EN_US.png',
    active: true,
  },
  {
    value: 'es-PE',
    country: 'PER',
    description: 'ES-PE',
    img: '../../assets/img/flags/Icon_ES_PE.png',
    active: true,
  },
  {
    value: 'es-CL',
    country: 'CHL',
    description: 'ES-CL',
    img: '../../assets/img/flags/Icon_ES_CL.png',
    active: true,
  },
  {
    value: 'es-CO',
    country: 'COL',
    description: 'ES-CO',
    img: '../../assets/img/flags/Icon_ES_CO.png',
    active: true,
  },
  {
    value: 'es-EC',
    country: 'ECU',
    description: 'ES-EC',
    img: '../../assets/img/flags/Icon_ES_EC.png',
    active: true,
  },
  {
    value: 'es-VE',
    country: 'VEN',
    description: 'ES-VE',
    img: '../../assets/img/flags/Icon_ES_VE.png',
    active: true,
  },
];
